/**
 * @fileoverview Utility functions for generating normalized hash IDs.
 */

import {v5} from "uuid";
import {kebabCase} from "lodash";

/**
 * UUID namespace for generating consistent hash IDs.
 */
export const namespace = "00000000-0000-0000-0000-000000000000";

/**
 * Generates a normalized hash ID from text using UUID v5 and kebab-case formatting.
 *
 * @param {string} text The text to generate a hash ID from.
 * @returns {string} A normalized hash ID.
 */
export const getNormalizedHashId = (text: string): string =>
  v5(kebabCase(text), namespace);
